<ng-container *ngIf="params && params.data">
  <div *ngIf="params.data.IsLoading" class="text-center">
    <i class="fas fa-lg fa-circle-notch fa-spin"></i>
  </div>

  <div *ngIf="params.data.Error" class="text-center">
    <i
      class="fas fa-lg fa-times"
      style="border-radius: 30px; padding: 8px; background-color: #ff4300; color: white">
    </i>
  </div>
  <div *ngIf="params.data.Warning" class="text-center">
    <i
      class="fas fa-exclamation-triangle"
      style="border-radius: 30px; padding: 8px; background-color: #ffc113; color: #fff">
    </i>
  </div>
  <!--
    task 13616
    special override to show info message when Manual Check paylines are not checked ok to pay
  -->
  <div *ngIf="params.data.Info" class="text-center">
    <i
      class="fas fa-lg fa-info-circle"
      style="border-radius: 30px; padding: 9px 7px 9px 6px; background-color: #13e3ff; color: #fff">
    </i>
  </div>
</ng-container>
